import React, { useRef, useState } from 'react';
import { IOperateItem, QuestionOperateType } from '../../../../interface/multiCapabilityTemplate';
import { Button, Iconfont, UmuInput } from '@umu/umu-design';
import { If } from 'common/src/components';
import { getUploadResult } from '../../../../../../services/uploader/uploader';

interface AutoSizeType {
    minRows?: number;
    maxRows?: number;
}
interface IProps {
    value: string;
    preCls?: string;
    className?: string;
    prefix: string | JSX.Element;
    externalList?: IOperateItem[];
    placeholder?: string;
    autoSize?: boolean | AutoSizeType;
    internalList?: IOperateItem[];
    prefixElement?: JSX.Element | string;
    onFocus?: () => void;
    onPressEnter?: () => void;
    onCommunication: (type: QuestionOperateType, data?: any) => Promise<boolean>;
}

const { Textarea } = UmuInput;
const QuestionInput = (props: IProps) => {
    const {
        preCls,
        prefix,
        internalList = [],
        placeholder = '',
        autoSize = true,
        externalList = [],
        value = '',
        prefixElement = '',
        className = '',
        onPressEnter,
        onFocus,
        onCommunication,
    } = props;
    const inputRef = useRef<HTMLInputElement>(null);
    const [fileAccepts, setFileAccepts] = useState({
        key: '',
        value: '',
    });
    const renderInternalList = () => {
        // 内部操作列表以图标展示
        return internalList.map((item) => {
            return (
                <Iconfont
                    key={item.key}
                    type={item?.iconType || ''}
                    className={`icon-item icon-split ${item?.className || ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (item.isUploadFile) {
                            setFileAccepts({
                                key: String(item.key),
                                value: item.accept || '',
                            });
                            inputRef.current?.click();
                            return;
                        } else {
                            onCommunication(item.key, {});
                        }
                    }}
                ></Iconfont>
            );
        });
    };
    const renderExternalList = () => {
        // 外部操作列表以按钮展示
        return externalList.map((item) => {
            const { label, key, className = '', onClick, ...rest } = item;
            const btnType = item?.type || 'text';
            return (
                <Button
                    key={key}
                    type={btnType}
                    className={`btn-split ${className}`}
                    isOnlyChildren={btnType === 'text'}
                    {...rest}
                    onClick={(e) => {
                        if (onClick) {
                            onClick(e);
                        }
                        onCommunication(key);
                    }}
                >
                    {label}
                </Button>
            );
        });
    };
    const onUploadImg = async (blob: Blob, teacherId: string = '') => {
        const previewUrl = window.URL.createObjectURL(blob);

        const param: any = {
            blob,
            ext: 'png',
            previewUrl,
            fileName: '',
            mediaType: 'imageweike',
            teacherId,
        };
        const urls = await getUploadResult(param);
        return urls;
    };
    const onChangeFile = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = ev.target.files;
        if (!fileList || !fileList.length) {
            return;
        }
        const files = Array.from(fileList);
        const reader = new FileReader();
        reader.readAsArrayBuffer(files[0]);

        reader.onload = async (e) => {
            if (e.target && e.target.result) {
                const resourceInfo = await onUploadImg(new Blob([e.target.result]));
                onCommunication(Number(fileAccepts.key) as QuestionOperateType, { resourceInfo });
            }
        };
        ev.target.value = '';
    };
    return (
        <div className={`${preCls} ${className}`}>
            {prefixElement && <div className={`${preCls}-ele-prefix`}>{prefixElement}</div>}
            <div className={`${preCls}-info`}>
                {prefix && <div className={`${preCls}-prefix`}>{prefix}</div>}
                <div className={`${preCls}-hide-border textarea-info`}>
                    <Textarea
                        value={value}
                        onChange={(e) => onCommunication(QuestionOperateType.CHANGE_CONFIG, { title: e.value })}
                        expandConfig={{
                            autoSize,
                            placeholder,
                            onFocus,
                            onPressEnter,
                        }}
                    ></Textarea>
                </div>
                <If condition={externalList.length > 0}>
                    <div className={`${preCls}-internal-list btn-list view-hide`}>{renderInternalList()}</div>
                </If>
            </div>
            <If condition={externalList.length > 0}>
                <div className={`${preCls}-external-list btn-list view-hide`}>{renderExternalList()}</div>
            </If>
            <input
                type="file"
                title=""
                ref={inputRef}
                accept={fileAccepts?.value || ''}
                style={{ display: 'none' }}
                onChange={onChangeFile}
            />
        </div>
    );
};

export { QuestionInput };
